export const messages = {
  en: {
    evBike: {
      plateNumber: 'Plate Number',
      brandModel: 'Brand & Model',
      ownerName: 'Owner Name',
      ownerType: 'Owner Type',
      ownerTypeOwner: 'Owner',
      ownerTypeMember: 'Family Member',
      ownerPhone: 'Owner Phone',
      issueStatus: 'Card Issue Status',
      issuePending: 'Pending',
      issueDone: 'Issued',
      issueFailed: 'Issue Failed',
      cardNumber: 'Card Number',
      state: 'State',
      stateNormal: 'Normal',
      stateDisable: 'Disabled',
      stateLost: 'Lost',
      createTime: 'Create Time',
      room: 'Room',
      operation: 'Operation',
      addBike: 'Add Bike',
      editBike: 'Edit Bike',
      deleteBike: 'Delete Bike',
      inputPlateNumber: 'Please input plate number',
      inputBrandModel: 'Please input brand and model',
      inputOwnerName: 'Please input owner name',
      inputOwnerPhone: 'Please input owner phone',
      inputCardNumber: 'Please input card number',
      selectState: 'Please select state',
      inputRemark: 'Please input remark',
      plateNumberRequired: 'Plate number is required',
      ownerNameRequired: 'Owner name is required',
      ownerPhoneRequired: 'Owner phone is required',
      ownerPhoneInvalid: 'Invalid phone number format',
      ownerTypeRequired: 'Owner type is required',
      ownerOptionsLoadFailed: 'Failed to load owner members',
      saveError: 'Failed to save bike',
      deleteError: 'Failed to delete bike',
      confirmDelete: 'Are you sure to delete this bike?',
      remark: 'Remark',
      auditTitle: 'Audit EV Bike',
      auditResult: 'Audit Result',
      auditPass: 'Pass',
      auditReject: 'Reject',
      rejectReason: 'Reject Reason',
      rejectReasonPlaceholder: 'Please input the reason for rejection',
      rejectReasonRequired: 'Reject reason is required',
      auditSuccess: 'Audit successfully',
      auditFailed: 'Audit failed',
      cancel: 'Cancel',
      confirm: 'Confirm',
      issueTitle: 'Issue Card',
      issueCardSuccess: 'Issued successfully',
      issueCardFailed: 'Issue failed'
    },
    simplifyEvBike: {
      addBike: 'Add Bike',
      plateNumber: 'Plate Number',
      brandModel: 'Brand & Model',
      owner: 'Owner',
      phone: 'Phone',
      cardNumber: 'Card',
      issueStatus: 'Card Issue Status',
      issuePending: 'Pending',
      issueDone: 'Issued',
      issueFailed: 'Issue Failed',
      room: 'Room',
      status: 'Status',
      stateNormal: 'Normal',
      stateDisable: 'Disabled',
      stateLost: 'Lost',
      auditStatus: 'Audit Status',
      auditPending: 'Pending',
      auditPassed: 'Passed',
      auditRejected: 'Rejected',
      auditInfo: 'Auditor',
      createTime: 'Create Time',
      operation: 'Operation',
      audit: 'Audit',
      edit: 'Edit',
      delete: 'Delete',
      issue: 'Issue',
      reissue: 'Re-issue'
    },
    simplifyAcceptance: {
      evBike: 'EV Bike',
      houseNumber: 'House Number',
      ownerName: 'Owner Name',
      ownerPhone: 'Owner Phone',
      ownerIdCard: 'ID Card',
      licensePlate: 'License Plate',
      memberName: 'Member Name',
      memberPhone: 'Member Phone',
      memberIdCard: 'Member ID Card',
      shopNumber: 'Shop Number',
      contractNumber: 'Contract Number',
      search: 'Search',
      selectHouse: 'Select House',
      moreOperations: 'More Operations',
      handover: 'Handover',
      exitRoom: 'Exit Room',
      ownerId: 'Owner ID',
      contactPhone: 'Contact Phone',
      idCard: 'ID Card',
      checkInDate: 'Check-in Date',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      ownerRemark: 'Owner Remark',
      houseArea: 'House Area',
      houseType: 'House Type',
      layout: 'Layout',
      houseStatus: 'House Status',
      indoorArea: 'Indoor Area',
      rent: 'Rent',
      houseRemark: 'House Remark',
      accountBalance: 'Account Balance',
      preDeposit: 'Pre-deposit',
      depositAmount: 'Deposit Amount',
      refundDeposit: 'Refund Deposit',
      houseFee: 'House Fee',
      parkingFee: 'Parking Fee',
      paymentHistory: 'Payment History',
      house: 'House',
      contract: 'Contract',
      familyMember: 'Family Member',
      vehicle: 'Vehicle',
      paymentReminder: 'Payment Reminder',
      ownerFeedback: 'Owner Feedback',
      repairOrder: 'Repair Order',
      complaintOrder: 'Complaint Order',
      ownerSync: 'Owner Sync',
      vehicleSync: 'Vehicle Sync',
      reprintReceipt: 'Reprint Receipt',
      historyOwner: 'History Owner',
      meterReadingRecord: 'Meter Reading Record',
      houseNumberPlaceholder: 'Please input house number',
      ownerNamePlaceholder: 'Please input owner name',
      ownerPhonePlaceholder: 'Please input owner phone',
      ownerIdCardPlaceholder: 'Please input owner ID card',
      licensePlatePlaceholder: 'Please input license plate',
      memberNamePlaceholder: 'Please input member name',
      memberPhonePlaceholder: 'Please input member phone',
      memberIdCardPlaceholder: 'Please input member ID card',
      shopNumberPlaceholder: 'Please input shop number',
      contractNumberPlaceholder: 'Please input contract number',
      inputSearchCondition: 'Please input search condition',
      selectHouseFirst: 'Please select house first'
    }
  },
  zh: {
    evBike: {
      plateNumber: '车牌号',
      brandModel: '品牌型号',
      ownerName: '车主姓名',
      ownerType: '归属类型',
      ownerTypeOwner: '车主',
      ownerTypeMember: '家庭成员',
      ownerPhone: '车主电话',
      issueStatus: '发卡状态',
      issuePending: '待下发',
      issueDone: '已下发',
      issueFailed: '下发失败',
      cardNumber: '卡号',
      state: '状态',
      stateNormal: '正常',
      stateDisable: '停用',
      stateLost: '丢失',
      createTime: '创建时间',
      room: '房号',
      operation: '操作',
      addBike: '添加电动车',
      editBike: '编辑电动车',
      deleteBike: '删除电动车',
      inputPlateNumber: '请输入车牌号',
      inputBrandModel: '请输入品牌型号',
      inputOwnerName: '请输入车主姓名',
      inputOwnerPhone: '请输入车主电话',
      inputCardNumber: '请输入卡号',
      selectState: '请选择状态',
      inputRemark: '请输入备注',
      plateNumberRequired: '车牌号不能为空',
      ownerNameRequired: '车主姓名不能为空',
      ownerPhoneRequired: '车主电话不能为空',
      ownerPhoneInvalid: '手机号格式不正确',
      ownerTypeRequired: '请选择归属类型',
      ownerOptionsLoadFailed: '加载成员信息失败',
      saveError: '保存电动车失败',
      deleteError: '删除电动车失败',
      confirmDelete: '确定要删除这辆电动车吗？',
      remark: '备注',
      auditTitle: '审核电动车',
      auditResult: '审核结果',
      auditPass: '通过',
      auditReject: '驳回',
      rejectReason: '驳回原因',
      rejectReasonPlaceholder: '请输入驳回原因',
      rejectReasonRequired: '驳回原因不能为空',
      auditSuccess: '审核成功',
      auditFailed: '审核失败',
      cancel: '取消',
      confirm: '确定',
      issueTitle: '发卡',
      issueCardSuccess: '下发成功',
      issueCardFailed: '下发失败'
    },
    simplifyEvBike: {
      addBike: '添加电动车',
      plateNumber: '车牌号',
      brandModel: '品牌型号',
      owner: '车主',
      phone: '电话',
      cardNumber: '卡号',
      issueStatus: '发卡状态',
      issuePending: '待下发',
      issueDone: '已下发',
      issueFailed: '下发失败',
      room: '房号',
      status: '状态',
      stateNormal: '正常',
      stateDisable: '停用',
      stateLost: '丢失',
      auditStatus: '审核状态',
      auditPending: '待审核',
      auditPassed: '已通过',
      auditRejected: '已驳回',
      auditInfo: '审核人',
      createTime: '创建时间',
      operation: '操作',
      audit: '审核',
      edit: '编辑',
      delete: '删除',
      issue: '下发',
      reissue: '重新下发'
    },
    simplifyAcceptance: {
      evBike: '电动车',
      houseNumber: '房号',
      ownerName: '业主姓名',
      ownerPhone: '业主电话',
      ownerIdCard: '业主身份证',
      licensePlate: '车牌号',
      memberName: '成员姓名',
      memberPhone: '成员电话',
      memberIdCard: '成员身份证',
      shopNumber: '商铺编号',
      contractNumber: '合同编号',
      search: '搜索',
      selectHouse: '选择房屋',
      moreOperations: '更多操作',
      handover: '交房',
      exitRoom: '退房',
      ownerId: '业主编号',
      contactPhone: '联系电话',
      idCard: '身份证号',
      checkInDate: '入住时间',
      gender: '性别',
      male: '男',
      female: '女',
      ownerRemark: '业主备注',
      houseArea: '房屋面积',
      houseType: '房屋类型',
      layout: '户型',
      houseStatus: '房屋状态',
      indoorArea: '套内面积',
      rent: '租金',
      houseRemark: '房屋备注',
      accountBalance: '账户余额',
      preDeposit: '预存',
      depositAmount: '押金金额',
      refundDeposit: '退押金',
      houseFee: '房屋费用',
      parkingFee: '停车费用',
      paymentHistory: '缴费历史',
      house: '房屋',
      contract: '合同',
      familyMember: '家庭成员',
      vehicle: '车辆',
      paymentReminder: '催缴',
      ownerFeedback: '业主反馈',
      repairOrder: '报修单',
      complaintOrder: '投诉单',
      ownerSync: '业主同步',
      vehicleSync: '车辆同步',
      reprintReceipt: '补打收据',
      historyOwner: '历史业主',
      meterReadingRecord: '抄表记录',
      houseNumberPlaceholder: '请输入房号',
      ownerNamePlaceholder: '请输入业主姓名',
      ownerPhonePlaceholder: '请输入业主电话',
      ownerIdCardPlaceholder: '请输入业主身份证',
      licensePlatePlaceholder: '请输入车牌号',
      memberNamePlaceholder: '请输入成员姓名',
      memberPhonePlaceholder: '请输入成员电话',
      memberIdCardPlaceholder: '请输入成员身份证',
      shopNumberPlaceholder: '请输入商铺编号',
      contractNumberPlaceholder: '请输入合同编号',
      inputSearchCondition: '请输入搜索条件',
      selectHouseFirst: '请先选择房屋'
    }
  }
}
